import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button';

import TwitterIcon from '../assets/twitter-icon.png';
import DiscordIcon from '../assets/discord-icon.png';
import MenuIcon from '../assets/menu.svg';
import { Drawer } from '@mui/material';

function ResponsiveAppBar(props) {

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    useEffect(() => {

    }, []);

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setIsDrawerOpen(open);
    };

    const openHome = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    const openHowToPlay = () => {
        window.open('https://raonwars.gitbook.io/raonpaper/gameplay/how-to-play-game', "_blank", "noreferrer");
    };

    const openRaonpaper = () => {
        window.open('https://raonwars.gitbook.io/raonpaper', "_blank", "noreferrer");
    };

    const openTwitter = () => {
        window.open('https://twitter.com/Raonwars', "_blank", "noreferrer");
    };

    const openDiscord = () => {
        window.open('https://discord.gg/yNPudUpJ9g', "_blank", "noreferrer");
    };

    return (
        <div>
            {
                props.isMobile ?
                    <div className='nav-mobile'>
                        <img src={MenuIcon} alt='Menu' onClick={toggleDrawer(true)}></img>
                        <div className='app-bar-logo'>R</div>
                    </div> :
                    <div className='nav'>
                        <div>
                            <Button variant="contained" className='nav-button' onClick={openHome}>Home</Button>
                            <Button variant="contained" className='nav-button' onClick={openHowToPlay}>How to Play</Button>
                            <Button variant="contained" className='nav-button' onClick={openRaonpaper}>RaonPaper</Button>
                        </div>
                        <div>
                            <Button variant="contained" className='nav-button' onClick={openTwitter}><img src={TwitterIcon} alt='Twitter' className='button-icon'></img> Twitter</Button>
                            <Button variant="contained" className='nav-button' onClick={openDiscord}><img src={DiscordIcon} alt='Discord' className='button-icon'></img> Discord</Button>
                        </div>
                    </div>
            }

            <Drawer
                anchor={'left'}
                open={isDrawerOpen}
                onClose={toggleDrawer(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: "#c6643e",
                    }
                }}
            >
                <Button variant="contained" className='nav-button' onClick={openHome}>Home</Button>
                <Button variant="contained" className='nav-button' onClick={openHowToPlay}>How to Play</Button>
                <Button variant="contained" className='nav-button' onClick={openRaonpaper}>RaonPaper</Button>
                <Button variant="contained" className='nav-button' onClick={openTwitter}><img src={TwitterIcon} alt='Twitter' className='button-icon'></img> Twitter</Button>
                <Button variant="contained" className='nav-button' onClick={openDiscord}><img src={DiscordIcon} alt='Discord' className='button-icon'></img> Discord</Button>
            </Drawer>
        </div>

    );
}
export default ResponsiveAppBar;